import { Inertia } from '@inertiajs/inertia'
import { Component, Event, EventEmitter, Fragment, getAssetPath, h, Prop } from '@stencil/core'
import Axios from 'axios'
import { IBanner } from 'src/app'
import { flashToast } from 'src/app/toast'
import { GameStore } from 'src/gamification/ui'
import { dismissBanner } from 'src/gamification/ui'
import { InlineIconText } from 'src/ui/components'

function formatDomain(domain) {
  return domain.includes('@') ? domain : '@' + domain
}

@Component({
  tag: 'team-onboarding-education-modal',
  assetsDirs: ['assets'],
})
export class TeamOnboardingEducationModal {
  @Event() closed: EventEmitter
  @Prop() banner: IBanner

  render() {
    const hidePoints = !GameStore.state.isEnabled

    return (
      <ui-dialog
        content={({ dialog }) => (
          <div
            class='flex relative flex-col p-3 mx-auto bg-surface-upper rounded-md border-1 border-surface-high'
            style={{ minWidth: '994px' }}
          >
            <ui-icon
              onClick={async () => {
                await dialog.close()
              }}
              class='ml-auto text-3xl text-glyph-light hover:text-glyph-base cursor-pointer'
              icon='x'
              tabIndex={0}
            />
            <div class='flex flex-col items-center spacing-y-2'>
              <span class='font-medium text-glyph-lighter uppercase'>One Last Thing</span>
              <span class='text-3xl font-bold text-center'>
                Learn how to use Team Edition
                {!hidePoints && (
                  <Fragment>
                    {' '}
                    and earn{' '}
                    <InlineIconText icon='coin-star-fill' class='pl-1 text-info-warn whitespace-nowrap'>
                      <span class='font-extrabold'>25 Points</span>
                    </InlineIconText>
                  </Fragment>
                )}
              </span>

              <div class='flex relative flex-col items-center py-4 max-w-lg'>
                <div>
                  <img src={getAssetPath('./assets/team_tutorial_preview.png')} />
                </div>
                <div class='absolute mt-30 bg-black'>
                  <ui-button
                    color='info-warn'
                    icon='play'
                    iconStyle={{ fontSize: '25px' }}
                    uppercase={false}
                    class='w-64 text-lg'
                    href={this.banner.metadata.videoUrl}
                    target='_blank'
                    onClick={async () => {
                      try {
                        await Axios.put(this.banner.metadata.completed_team_education_url)
                      } catch (ex) {
                        flashToast({
                          type: 'alert',
                          text: `There was a problem updating your points. Please try again.`,
                        })
                      }
                    }}
                  >
                    <span class='font-extrabold'>Watch Demo</span>
                    <span class='ml-1 font-medium'>- 5 min</span>
                  </ui-button>
                </div>
              </div>

              <div class='flex justify-between px-20 pb-10 w-100%'>
                <div class='flex flex-row items-center pr-3'>
                  <ui-icon class='pr-1 text-green' icon='check' size='xl' />
                  Anyone from {formatDomain(this.banner.metadata.team_domain)} can join your Fathom workspace
                </div>
                <div>
                  <button
                    onClick={async (event) => {
                      event.preventDefault()
                      await dismissBanner(this.banner)
                      await dialog.close()
                      Inertia.visit(this.banner.metadata.customizePageUrl)
                    }}
                    class='flex gap-6px items-center font-semibold text-link hover:underline'
                  >
                    <ui-icon icon='gear' />
                    <span>Edit Settings</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    )
  }
}
